<template>
  <div>
    <account></account>
  </div>
</template>


<script>
import Account from './../../components/account/index';
export default {
  data: () => ({}),
  metaInfo() {
    return {
      title: this.$t('account.title'),
    };
  },
  components: {
    Account
  }
}
</script>